import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { InwardEndToEndSlaService } from "./service/widget-sla-graph.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import * as HSET from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);

@Component({
  selector: "widget-sla-graph",
  templateUrl: "./widget-sla-graph.component.html",
  styleUrls: ["./widget-sla-graph.component.scss"],
  providers: [InwardEndToEndSlaService]
})
export class WidgetSlaGraphComponent implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;
  widgetId = 12;
  highcharts: typeof Highcharts = Highcharts;
  chartOption1 = null;
  errorMessage = "";
  chartOption2 = HSET.chart2;
  mockChart = null;
  mockChart2 = null;
  loadingChart = true;

  constructor(
    private translateService: TranslateService,
    private dataService: InwardEndToEndSlaService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getEndToEndSLA();
    }
  }

  ngOnInit() {
    this.translateService
      .get("PERFORMANCE.TRANSFER.END_TO_END_SLA")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
    this.broadcaster.listen("PAGE_WIDGET_DATA")
      .pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.setWidgetData();
      });
    this.getEndToEndSLA();
  }
  setWidgetData() {
    const pageData = this.localStorageService.getItem("PAGE_WIDGET_DATA");
    if (pageData) {
      pageData.forEach(element => {
        if (element.widget_id === this.widgetId) {
          this.setTarget(element.target);
        }
      });
    }
  }

  setTarget(t) {
    if (this.chartOption2) {
      this.chartOption2.series[3].data = [];
      for (let i = 0; i < this.chartOption2.series[0].data.length; i++) {
        this.chartOption2.series[3].data.push(t);
      }
    }
  }
  getEndToEndSLA() {
    this.loadingChart = true;
    this.mockChart = null;
    this.mockChart2 = null;
    this.chartOption1 = null;
    this.errorMessage = "";
    this.chartOption2.series[0].data = [];
    this.dataService.getEndToEndSLA(this.OPTIONS.api, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {
          if (chartData === null) {
            this.loadingChart = true;
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockChart = HSET.chart1;
            this.mockChart2 = HSET.chart2;
          } else {
            const charts = this.dataService.createChart(chartData, this.OPTIONS);
            this.chartOption1 = charts.chart1;
            this.chartOption2 = charts.chart2;
            this.setWidgetData();
            this.loadingChart = false;
          }
        },
        error => {
          this.loadingChart = true;
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockChart = HSET.chart1;
          this.mockChart2 = HSET.chart2;
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
